import React, { ReactNode, Ref, RefObject } from 'react';
import { withEndlessScroll } from '../HOC/endlessScroll';
import { BusinessItemsListContainer, BusinessItemsType } from './types';

export interface BusinessItemsListProps {
  forwardedRef?: Ref<HTMLDivElement>;
  ListContainer: BusinessItemsListContainer;
  isEmptyView: boolean;
  type: BusinessItemsType;
  children?: ReactNode;
}

export const BusinessItemsList: React.FC<BusinessItemsListProps> = ({
  forwardedRef,
  ListContainer,
  isEmptyView,
  type,
  children
}) => (
  <ListContainer
    ref={forwardedRef}
    $isEmptyView={isEmptyView}
    data-cy={`${type}-page-list`}
  >
    {children}
  </ListContainer>
);

type BusinessItemsListScrollProps = Omit<
  BusinessItemsListProps,
  'forwardedRef'
> & {
  forwardedRef: RefObject<HTMLDivElement>;
};

const BusinessItemsListForScroll: React.FC<
  BusinessItemsListScrollProps
> = props => <BusinessItemsList {...props} />;

export const EndlessBusinessItemsList = withEndlessScroll(
  BusinessItemsListForScroll
);
